import { Injectable } from "@angular/core";
import { GenericHttpService } from "../../../../shared/services/generic-http.service";
import { environment } from "../../../../../environments/environment";
import { catchError, map } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class MenuSearchBarService {
  constructor(public generic: GenericHttpService) {}

  apiUrl = environment.gateWayHost;

  getSearchData(url, params): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.apiUrl}${url}`,
      query: {...params, search: true}
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.generic.responseData)
    );
  }
}
